import React, { useEffect } from "react"
import { Button, Input, Spin, Typography } from "antd"
import { TokenCheckType, useManagerChangePasswdByTokenMutation, useUserTokenCheckQuery } from "../../generated-types"
import { useNavigate, useParams } from "react-router-dom"
import { handleGqlError } from "../../utils/utils"
import { toast } from "react-toastify"
import { useTranslation } from "react-i18next"

export default () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const { token } = useParams<any>()
  const [passwd1, setPasswd1] = React.useState("")
  const [passwd2, setPasswd2] = React.useState("")

  const { data } = useUserTokenCheckQuery({
    variables: { token, type: TokenCheckType.ChangePwd },
    skip: !token,
    onError: (e) => {
      handleGqlError(e, (msg) => toast(msg, { type: "error" }))
      navigate("/")
    },
  })
  const [changeMutation, { loading }] = useManagerChangePasswdByTokenMutation({
    fetchPolicy: "no-cache",
    onError: (e) => handleGqlError(e, (msg) => toast(msg, { type: "error" })),
  })

  useEffect(() => {
    if (!data) return
    if (!data.userTokenCheck) {
      toast(t("change-pwd.invalid-access"), { type: "error" })
      navigate("/")
    }
  }, [data])

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#00739D" }}>
      <form
        onSubmit={(e) => {
          e.preventDefault()
          if (passwd1 !== passwd2) {
            toast(t("change-pwd.password-mismatch"), { type: "error" })
            return false
          }
          changeMutation({ variables: { token, newPasswd: passwd1 } }).then(() => {
            toast(t("change-pwd.success"), { type: "success" })
            navigate("/")
          })
        }}
      >
        <div style={{ background: "white", borderRadius: "12px", padding: "24px", width: "400px", display: "flex", flexDirection: "column", gap: "12px" }}>
          <Typography.Title level={2} style={{ textAlign: "center", margin: "8px 0" }}>
            {t("change-pwd.title")}
          </Typography.Title>
          <Input placeholder={t("session.key.Email.word")} value={data?.userTokenCheck?.email} required disabled />
          <Input
            placeholder={t("change-pwd.new")}
            value={passwd1}
            onChange={(e) => setPasswd1(e.target.value)}
            required
            type="password"
            disabled={loading}
          />
          <Input
            placeholder={t("change-pwd.confirm-new")}
            value={passwd2}
            onChange={(e) => setPasswd2(e.target.value)}
            required
            type="password"
            disabled={loading}
          />
          <div style={{ position: "relative" }}>
            <Button type="primary" htmlType="submit" block disabled={loading}>
              {t("common.confirm.word")}
            </Button>
            {loading && (
              <Spin style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)" }} />
            )}
          </div>
        </div>
      </form>
    </div>
  )
}
